import { Component, computed, signal, ChangeDetectionStrategy } from '@angular/core';
import { faker } from '@faker-js/faker';

import { MdwAvatar } from '@spaces-ui/meadow/components/avatar';
import { MdwChip, MdwTiptapChipListInput } from '@spaces-ui/meadow/components/chip';
import { QuillMentionMatch } from '@spaces-ui/meadow/helpers/quill-helpers';
import { MdwIcon } from '@spaces-ui/meadow/icons';
import { Apple_Fill } from '@spaces-ui/meadow/icons/svgs';

import { Sample } from '../../components';

interface User {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  fullName: string;
  avatarColor: number;
}

@Component({
  selector: 'app-chips',
  templateUrl: './chips.html',
  styleUrls: ['./chips.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MdwChip, Sample, MdwIcon, MdwAvatar, MdwTiptapChipListInput],
})
export class Chips {
  public icons = { Apple_Fill };

  public users = this.generateUsers();
  public selectedUsers = signal<User[]>([]);
  public selectedUserNames = computed(() => {
    const selectedUsers = this.selectedUsers();

    return selectedUsers.map(user => user.fullName).join(', ');
  });

  public toMentionMatch = (user: User) => {
    return {
      id: user.id,
      value: user.fullName ?? user.email,
      avatarColor: user.avatarColor,
      secondaryValue: user.email,
    } as QuillMentionMatch;
  };

  public fromMentionMatch = (mentionMatch: QuillMentionMatch) => {
    const user = this.users.find(user => user.id === mentionMatch.id);
    return user as User;
  };

  private generateUsers() {
    return Array.from({ length: 1000 }, () => {
      const id = faker.string.uuid();
      const firstName = faker.person.firstName();
      const lastName = faker.person.lastName();
      const email = faker.internet.email({ firstName, lastName });
      const fullName = `${firstName} ${lastName}`;

      return {
        id,
        firstName,
        lastName,
        email,
        fullName,
        avatarColor: faker.number.int({ min: 1, max: 7 }),
      } as User;
    });
  }
}
